import FormHandler from "formhandler.js";
import IMask from "imask";

export default {
    init() {
        const shippingSelector = document.querySelector('.js-shipping-selector');
		const shippingInput = document.querySelectorAll('.js-shipping-input');
		
		const paymentSelector = document.querySelectorAll('.js-payment-selector');
        const paymentInput = document.querySelectorAll('.js-payment-input');

        const cardMaskElement = document.querySelector("[data-imask='card-number']");
        const cvcMaskElement = document.querySelector("[data-imask='cvc-number']");

        const paymentSubmit = document.querySelector(".js-payment-submit");

		paymentSubmit.addEventListener('click', function(event) {
                event.preventDefault();
            }
        );

		this.handleShippingChange(shippingSelector, shippingInput);

		if (document.querySelector('input[name="payment_method"]:checked')) {
			this.handlePaymentChange(paymentSelector, paymentInput);
		}

		if(cardMaskElement) {
			this.maskCreditCardNumber(cardMaskElement);
		}

		if(cvcMaskElement) {
			this.maskCvcNumber(cvcMaskElement);
		}
        
        this.handleForm();
	},

    handleShippingChange(shippingSelector, shippingInput) {

        if(shippingSelector) {
            shippingInput.forEach((radio) => {
				radio.addEventListener('click', (event) => {
					const form = document.forms.checkout;
					const formData = new FormData(form);
					const data = [...formData.entries()];
					const asString = data
						.map(x => `${encodeURIComponent(x[0])}=${encodeURIComponent(x[1])}`)
						.join('&');
					console.log(asString);

					let getUrl = window.location;
                    let baseUrl = getUrl .protocol + "//" + getUrl.host;

                    window.location.href = baseUrl + "/cart/update-shipping?user_id=" + radio.dataset.user + "&" + asString;
                });
            });
        }
	},
	
    handlePaymentChange(paymentSelector, paymentInput) {
		var selectedPaymentMethod = document.querySelector('input[name="payment_method"]:checked').value;

		//Set displays on innitial load
		if (selectedPaymentMethod == 'loyalty_points') {
			document.querySelector('.js-paygate-form').classList.add('display-none');
			document.querySelector('.js-loyalty-point-form').classList.remove('display-none');
			document.querySelector('.js-payment-notices').classList.add('display-none');
			document.querySelector('.js-payjustnow').classList.add('display-none');
			document.querySelector('.js-payflex').classList.add('display-none');
		}

		if (selectedPaymentMethod == 'payflex') {
			document.querySelector('.js-paygate-form').classList.add('display-none');
			document.querySelector('.js-loyalty-point-form').classList.add('display-none');
			document.querySelector('.js-payment-notices').classList.add('display-none');
			document.querySelector('.js-payjustnow').classList.add('display-none');
			document.querySelector('.js-payflex').classList.remove('display-none');
		}

		if (selectedPaymentMethod == 'payjustnow') {
			document.querySelector('.js-paygate-form').classList.add('display-none');
			document.querySelector('.js-loyalty-point-form').classList.add('display-none');
			document.querySelector('.js-payment-notices').classList.add('display-none');
			document.querySelector('.js-payflex').classList.add('display-none');
			document.querySelector('.js-payjustnow').classList.remove('display-none');
		}

        if(paymentSelector) {
            paymentInput.forEach((radio) => {
				radio.addEventListener('click', (event) => {
                   	if (event.target.value == 'loyalty_points') {
					   	document.querySelector('.js-loyalty-point-form').classList.remove('display-none');
					  	document.querySelector('.js-paygate-form').classList.add('display-none');
						document.querySelector('.js-payment-notices').classList.add('display-none');
						document.querySelector('.js-payjustnow').classList.add('display-none');
						document.querySelector('.js-payflex').classList.add('display-none');
					}
					else if (event.target.value == 'payflex') {
						document.querySelector('.js-payflex').classList.remove('display-none');
						document.querySelector('.js-paygate-form').classList.add('display-none');
						document.querySelector('.js-payment-notices').classList.add('display-none');
						document.querySelector('.js-loyalty-point-form').classList.add('display-none');
						document.querySelector('.js-payjustnow').classList.add('display-none');
					}
					else if (event.target.value == 'payjustnow') {
						console.log('here')
						document.querySelector('.js-payjustnow').classList.remove('display-none');
						document.querySelector('.js-paygate-form').classList.add('display-none');
						document.querySelector('.js-payment-notices').classList.add('display-none');
						document.querySelector('.js-loyalty-point-form').classList.add('display-none');
						document.querySelector('.js-payflex').classList.add('display-none');
					}
				   	else {
						document.querySelector('.js-paygate-form').classList.remove('display-none');
						document.querySelector('.js-loyalty-point-form').classList.add('display-none');
						document.querySelector('.js-payment-notices').classList.remove('display-none');
						document.querySelector('.js-payjustnow').classList.add('display-none');
						document.querySelector('.js-payflex').classList.add('display-none');
				   	}
                });
            });
        }
    },

    maskCreditCardNumber(element) {
        const creditCardMaskOptions = {
            mask: "0000000000000000",
        };

        const creditCardMask = IMask(element, creditCardMaskOptions);
    },

    maskCvcNumber(element) {
        const CvcmaskOptions = {
            mask: "000",
        };

        const cvcMask = IMask(element, CvcmaskOptions);
    },

    handleForm() {
		const $this = this;
		const validationFields = {
			shipping_country: {
				validation: "isNonEmpty",
			},
			shipping_address_2: {
				validation: "isNonEmpty",
			},
			shipping_city: {
				validation: "isNonEmpty",
			},
			shipping_province: {
				validation: "isNonEmpty",
			},
			shipping_postcode: {
				validation: "isNonEmpty",
			},
			payment_card_holder: {
				validation: "isCustomFullName",
			},
			payment_card_number: {
				// Visa digits: 16
				// Mastercard digits: 16
				validation: "isNonEmpty",
				max: 16,
				min: 16
			},
			payment_expiry_month: {
				validation: "isNonEmpty",
			},
			payment_expiry_year: {
				validation: "isNonEmpty",
			},
			payment_cvc: {
				// Visa digits: 3
				// Mastercard digits: 3
				validation: "isNonEmpty",
				max: 3,
				min: 3
			},
		}
		
		if (document.querySelector('.js-names')) {
			validationFields.first_name = {
				validation: "isNonEmpty",
			}
			validationFields.last_name = {
				validation: "isNonEmpty",
			}
		}

        const paymentHandler = new FormHandler({
            form: {
                block: ".js-payment-form",
                submit: ".js-payment-submit",
                delayForNotice: 100000,
                notice: {
                    appendTo: ".js-payment-notices",
                    message: "Form is invalid. Please check your details and try again.",
                    succesMessage: "Form successfully sent.",
                    errorMessage: "Oops, something went wrong. Please try again later.",
                }
            },
            fields: validationFields,
            customValidations: {
                isCustomFullName(node) {
                    // pattern accepts:
                    // fullname: "Name Middle Surname";
                    // spaces: "Van de Merwe";
                    // hyphens: "Mary-Jane";
                    // apostrophes: "O'Neill";
                    // dot: "J.P. Theron"

                    const pattern = /^(\s)*[A-Za-z]+((\s)?((\'|\-|\.)?([A-Za-z])*))*(\s)*$/
                    let valid = pattern.test(node.value),
                        message = 'Name is invalid';

                    return {
                        valid,
                        message,
                    };
				}
			},
            callbacks: {
                onSubmit(form, fields) {
                    testValidity(form, fields);
                },
            },
        });

        function testValidity(form, fields) {
			let parent = this;
			//If we are paying using SkinBucks, we don't need to validate CC fields
			let validateCard = !document.querySelector('.js-paygate-form').classList.contains('display-none')

			if (!validateCard) {
				form.submit();
			}
			else {
				if (paymentHandler.isFormValid() === true) {
					let button = document.querySelector('.js-payment-submit');

					//Change button text and prevent clicking again
					button.querySelector('.c-button__text').innerHTML = 'Processing...';
					button.classList.add('c-button--disabled');

					var data = JSON.stringify({
						"card":{
							"cardholder": fields.find(field => field.id == 'payment[card_holder]').value,
							"number": fields.find(field => field.id == 'payment[card_number]').value,
							"expiry_month": fields.find(field => field.id == 'payment[expiry_month]').value,
							"expiry_year": fields.find(field => field.id == 'payment[expiry_year]').value,
							"cvv": fields.find(field => field.id == 'payment[cvc]').value
						}
					});

					var config = {
						method: 'post',
						url: 'https://www.walletdoc.com/v1/tokens',
						headers: { 
							'Authorization': `Basic ${window.walletDocPublicKey}`, 
							'Content-Type': 'application/json'
						},
						data : data
					};
					
					axios(config)
					.then(function (response) {
						let input = document.createElement('input');
						let button = document.querySelector('.js-payment-submit');

						input.setAttribute('name', 'payment_token');
						input.setAttribute('value', response.data.id);
						input.setAttribute('type', 'hidden');
				
						form.appendChild(input);

						//Disable submit button to prevent multiple submissions
						button.disabled = true;

						form.submit();
					})
					.catch(function (error) {
						console.log(error.response.data);
						alert(error.response.data.error.message);
					});
				}
			}
        }

	},

    submit(form) {
        form.submit()
    }

}



